import React from "react";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { serviceDetails } from "../mock/mock";

const Services = () => {
  const navigate = useNavigate();
  const accents = ["var(--accent)", "var(--accent-2)", "var(--accent-3)", "var(--accent-4)"];
  return (
    <section id="services" className="section-pad bg-white border-b-2 border-[#0A0A0A]">
      <div className="container-x">
        <div className="max-w-3xl mb-14">
          <p className="eyebrow text-neutral-500">/ What We Do</p>
          <h2 className="mt-4 display text-4xl md:text-5xl font-extrabold uppercase leading-[0.95]">
            AI-Powered <span className="hl">Digital Engineering</span> Services
          </h2>
          <p className="mt-5 text-neutral-700 leading-relaxed">
            We embed intelligence at the heart of everything — from user-centric product design to
            automated backend processes across 30+ industries.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {serviceDetails.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <div
                key={s.slug}
                onClick={() => navigate(`/services/${s.slug}`)}
                className="card-brutal group p-7 cursor-pointer relative"
                style={{ "--ic": accents[i % accents.length] }}
                data-cursor
              >
                <span className="mono text-[11px] text-neutral-400 absolute top-4 right-5">{String(i + 1).padStart(2, "0")}</span>
                <div className="svc-icon w-12 h-12 border-2 border-[#0A0A0A] flex items-center justify-center mb-6">
                  <Icon className="text-[#0A0A0A] group-hover:text-[#F4F1EA] transition-colors" size={22} />
                </div>
                <h3 className="display text-lg font-bold uppercase leading-tight mb-3 flex items-start justify-between gap-2">
                  {s.title}
                  <ArrowUpRight size={18} className="shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                </h3>
                <p className="text-sm text-neutral-600 leading-relaxed">{s.short}</p>
                <span className="mono text-[11px] font-bold uppercase tracking-widest mt-5 inline-flex items-center gap-2">
                  Learn More <ArrowUpRight size={13} />
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
